import { useEffect, useState } from "react";
import { WifiOff, Wifi } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setWasOffline(true);
      
      // Hide "back online" message after 3 seconds
      setTimeout(() => setWasOffline(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return { isOnline, wasOffline };
}

export function OfflineIndicator() {
  const { isOnline, wasOffline } = useOnlineStatus();

  if (isOnline && !wasOffline) return null;

  return (
    <div className="fixed inset-x-4 bottom-20 z-50 animate-in slide-in-from-bottom-4 md:bottom-4 md:left-auto md:right-4 md:w-80">
      {!isOnline ? (
        <Alert variant="destructive" className="shadow-lg">
          <WifiOff className="size-4" />
          <AlertDescription>
            You're offline. Some features may be limited.
          </AlertDescription>
        </Alert>
      ) : wasOffline ? (
        <Alert className="border-success/20 bg-success/5 text-success-foreground shadow-lg dark:border-success/30 dark:bg-success/20 dark:text-success-foreground">
          <Wifi className="size-4" />
          <AlertDescription>Back online!</AlertDescription>
        </Alert>
      ) : null}
    </div>
  );
}
